import styled from "styled-components";
// import Theme from "../../Styles/Themes";
// import config from "../../Config/config.json"


export const Container = styled.div`
    display: none;
    position: fixed;
    z-index: 99999;
    width: 100px;
    background: radial-gradient(100% 95% at 95% 50%, #3E78AA 0%, #55965E 80%);
    height: 100vh;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    transition: 1s;
    &:hover {
        width: 280px;
    }
    @media (min-width: 720px) {
        display: flex;
    }
    @media (min-width: 1281px) {
        display: flex;
        width: 150px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: none;
    }
`;

export const Gradient = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: #006560;
    margin-right: 8px;
    width: 300px;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    overflow: hidden;
    transition: 1s;
    &:hover {
        // align-items: flex-start;
    }
`;

export const MenuHeader = styled.div`
    display: flex;
    height: 20vh;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

export const MenuContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 70vh;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width : 5px;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const MenuFooter = styled.div`
    display: flex;
    height: 10vh;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

export const MenuDivisor = styled.div`
    display: flex;
    width: 80%;
    padding: 5px 41px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #416B49;
    white-space: nowrap;

    color: #FFF;
    leading-trim: both;
    text-edge: cap;
    font-family: "Sarvatrik Latin VF";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;